import React from 'react';

import Text from 'components/Text/Text';
import { useCopyStore } from 'store';

import * as S from './OvalCTA.styles';

export interface OvalCTAProps {
  label: string;
}

const OvalCTA: React.FunctionComponent<OvalCTAProps> = ({ label, ...rest }) => {
  const { globalSettings } = useCopyStore(({ copy }) => copy);

  const hoverBackgroundColor =
    globalSettings?.buttonsHoverColor ||
    globalSettings?.buttonsHoverDefaultColors;

  return (
    <S.Wrapper hoverBackgroundColor={hoverBackgroundColor} {...rest}>
      <Text as="span" text={label} size="smallBody" />
    </S.Wrapper>
  );
};

export default OvalCTA;
